// removed by extract-text-webpack-plugin
module.exports = {"container":"WhyFly__container__2N9Eb","text":"WhyFly__text__1nQ5t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/WhyFly/WhyFly.scss
// module id = 371
// module chunks = 0